import { useContext } from "react";
import { FormContext } from "../../context/Form";

const useFormContext = () => {
  const formik = useContext(FormContext);
  return formik;
};

export default useFormContext;
